// extracted by mini-css-extract-plugin
export var button = "ButtonBuyNow-module--button--y-rUC";
export var buttonBuyNow = "ButtonBuyNow-module--buttonBuyNow--tl2oW";